/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Franchise_Suspend_ConfirmInputs */

const cs_franchise_suspend_confirm = /** @type {(inputs: Franchise_Suspend_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozastavit licenci pro ${i?.name}? Jejich uživatelé se nebudou moci přihlásit a nabídky zmizí z veřejného webu. Data zůstanou zachována.`)
};

const en_franchise_suspend_confirm = /** @type {(inputs: Franchise_Suspend_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suspend the license for ${i?.name}? Their users will be unable to sign in and their listings will disappear from the public website. Data is preserved.`)
};

/**
* | output |
* | --- |
* | "Suspend the license for {name}? Their users will be unable to sign in and their listings will disappear from the public website. Data is preserved." |
*
* @param {Franchise_Suspend_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_suspend_confirm = /** @type {((inputs: Franchise_Suspend_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Suspend_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_suspend_confirm(inputs)
	return cs_franchise_suspend_confirm(inputs)
});